module.exports = __webpack_public_path__ + "static/assets/68e06e7b119c78a4a2bacbd69427246e.svg";